<div class="sidebar">
  <div class="address-wrapper">
    <p class="back-link-container">
      <a (click)="closeMapButtonPressed()" class="back-link">Back to results</a>
    </p>
    <p class="place-address aligncenter">
      {{ location.address }}<br />
      {{ location.suburb }}<br />
      {{ location.city }} {{ location.postcode }}
    </p>
    <p>
      <a
        target="_blank"
        href="https://google.com/maps/dir/Current+Location/{{ location.latitude }},{{ location.longitude }}"
        class="link-btn-primary"
        >Get directions</a
      >
    </p>
    <h3>{{ locationType }} ({{ location.locationDetails.length }})</h3>
  </div>
  <sidebar-detail *ngFor="let locationDetail of location.locationDetails" [locationDetail]="locationDetail">
  </sidebar-detail>
</div>
